/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { RmCalculationType } from './RmCalculationType';
import {
    RmCalculationTypeFromJSON,
    RmCalculationTypeFromJSONTyped,
    RmCalculationTypeToJSON,
    RmCalculationTypeToJSONTyped,
} from './RmCalculationType';

/**
 * 
 * @export
 * @interface RmCalculationTypeMapping
 */
export interface RmCalculationTypeMapping {
    /**
     * 
     * @type {RmCalculationType}
     * @memberof RmCalculationTypeMapping
     */
    type: RmCalculationType;
    /**
     * 
     * @type {string}
     * @memberof RmCalculationTypeMapping
     */
    target: string | null;
}



/**
 * Check if a given object implements the RmCalculationTypeMapping interface.
 */
export function instanceOfRmCalculationTypeMapping(value: object): value is RmCalculationTypeMapping {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function RmCalculationTypeMappingFromJSON(json: any): RmCalculationTypeMapping {
    return RmCalculationTypeMappingFromJSONTyped(json, false);
}

export function RmCalculationTypeMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): RmCalculationTypeMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'type': RmCalculationTypeFromJSON(json['type']),
        'target': json['target'],
    };
}

export function RmCalculationTypeMappingToJSON(json: any): RmCalculationTypeMapping {
    return RmCalculationTypeMappingToJSONTyped(json, false);
}

export function RmCalculationTypeMappingToJSONTyped(value?: RmCalculationTypeMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': RmCalculationTypeToJSON(value['type']),
        'target': value['target'],
    };
}

